import { generateList } from '../lib/main'
import patterns from './patterns.yml'

generateList(patterns)
